/**
 * Component for rendering action items (edit, delete, view content)
 */

import React from 'react'
import { Icon, Tooltip, Popconfirm } from 'antd'
import { useTranslation } from 'react-i18next'
import DeleteIcon from '../../../../assets/bin.svg'
import EditIcon from '../../../../assets/ai_edit.svg'
import CheckIcon from '../../../../assets/check_icon.svg'
import CancelIcon from '../../../../assets/delete.svg'

const ActionItems = ({
  sectionTitle,
  item = null,
  index = 0,
  tindex = 0,
  wstatus,
  content,
  isModalVisible,
  editTopicStatus,
  editTopicIndex,
  editTopicTopIndex,
  onEdit,
  onSaveEdit,
  onCancelEdit,
  onDelete,
  onViewContent,
  onShowImages,
  isGeneratingContent
}) => {
  const { t } = useTranslation()

  const itemForGeneratedContent =
    content[sectionTitle] && content[sectionTitle][item]
  const itemGeneratedContent =
    itemForGeneratedContent && itemForGeneratedContent.generatedContent
  const isGenerationError =
    itemForGeneratedContent && itemForGeneratedContent.status === 'error'
  const images = itemForGeneratedContent && itemForGeneratedContent.img_path
  const references =
    itemForGeneratedContent && itemForGeneratedContent.references

  return (
    <div className="ai-course__table-of-content__pop-over__container">
      {itemGeneratedContent && !isGenerationError && (
        <Tooltip trigger={['hover']} title={t('v4:view_generate_content')}>
          <div
            className="ai-course__table-of-content__pop-over__generate"
            onClick={() =>
              onViewContent(
                sectionTitle,
                item,
                itemGeneratedContent,
                references
              )
            }
          >
            <Icon type="eye" />
          </div>
        </Tooltip>
      )}

      {isGenerationError && (
        <Tooltip trigger={['hover']} title={t('v4:generate_error')}>
          <div className="ai-course__table-of-content__pop-over__warning">
            <Icon type="exclamation-circle" />
          </div>
        </Tooltip>
      )}

      {!isGeneratingContent &&
      isModalVisible &&
      editTopicStatus &&
      editTopicTopIndex === tindex &&
      index === -1 ? (
        <>
          <div
            className="ai-course__table-of-content__pop-over__edit"
            onClick={onSaveEdit}
          >
            <Tooltip
              trigger={['hover']}
              title={`${t('buttons:edit')} ${
                item ? t('labels:topic') : t('general:lesson')
              }`}
            >
              <img src={CheckIcon} alt="delete" className="delete-icon" />
            </Tooltip>
          </div>
          <div
            className="ai-course__table-of-content__pop-over__delete"
            onClick={onCancelEdit}
          >
            <Tooltip
              trigger={['hover']}
              title={`${t('v4:delete')} ${
                item ? t('labels:topic') : t('general:lesson')
              }`}
            >
              <img src={CancelIcon} alt="delete" className="delete-icon" />
            </Tooltip>
          </div>
        </>
      ) : isModalVisible &&
        editTopicTopIndex === tindex &&
        editTopicIndex === index ? (
        <>
          <div
            className="ai-course__table-of-content__pop-over__edit"
            onClick={onSaveEdit}
          >
            <Tooltip
              trigger={['hover']}
              title={`${t('buttons:edit')} ${
                item ? t('labels:topic') : t('general:lesson')
              }`}
            >
              <img src={CheckIcon} alt="delete" className="delete-icon" />
            </Tooltip>
          </div>
          <div
            className="ai-course__table-of-content__pop-over__delete"
            onClick={onCancelEdit}
          >
            <Tooltip
              trigger={['hover']}
              title={`${t('v4:delete')} ${
                item ? t('labels:topic') : t('general:lesson')
              }`}
            >
              <img src={CancelIcon} alt="delete" className="delete-icon" />
            </Tooltip>
          </div>
        </>
      ) : (
        <>
          <div
            className="ai-course__table-of-content__pop-over__edit"
            onClick={() => onEdit(sectionTitle, item, index, tindex, wstatus)}
          >
            <Tooltip
              trigger={['hover']}
              title={`${t('buttons:edit')} ${
                item ? t('labels:topic') : t('general:lesson')
              }`}
            >
              <img src={EditIcon} alt="delete" className="delete-icon" />
            </Tooltip>
          </div>
          <div className="ai-course__table-of-content__pop-over__delete">
            <Popconfirm
              icon={null}
              title={`${t('v5:are_you_sure_delete_file_confirm')} ${
                item ? t('labels:topic') : t('general:lesson')
              }? ${item ? '' : t('v4:all_topic_in_this_lesson')}`}
              onConfirm={() => onDelete(sectionTitle, item)}
            >
              <Tooltip
                trigger={['hover']}
                title={`${t('v4:delete')} ${
                  item ? t('labels:topic') : t('general:lesson')
                }`}
              >
                <img src={DeleteIcon} alt="delete" className="delete-icon" />
              </Tooltip>
            </Popconfirm>
          </div>
        </>
      )}
    </div>
  )
}

export default ActionItems
